module.exports = __webpack_public_path__ + "img/img_2.e7af6b94.png";